import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SpeechService {
  ENDPOINT = 'https://tdivns4plg.execute-api.ap-south-1.amazonaws.com/dev/speak';
  constructor(private http:HttpClient) {}
  
  speak(data) {
    return this.http.post(this.ENDPOINT, data);
  }
}